import React from 'react'
import { ConfirmationRoleAction } from '../../../legacy-design-system/action'
import { RenderDialogProps } from '../../../legacy-design-system/action/confirmation-action'
import {
  ModifyServerTagsByFilterDialog,
  ModifyServerTagsDialog
} from './tag-dialog'
import { Role } from '@contrast-security-inc/base-types'
import { PureQueryOptions } from 'apollo-client'
import { Placement } from '../../../legacy-design-system/popper'
import { getInitialTags, TagCount } from '../../../legacy-design-system/tags'
import { IconTag } from '@contrast-security-inc/design-system-foundations'
import { ConfirmationRoleActionProps } from '../../../legacy-design-system/action/confirmation-role-action'

interface Server {
  id: string
  tags: string[]
}

interface BulkActionProps extends Pick<ConfirmationRoleActionProps, 'size'> {
  servers: Server[]
  organizationID: string
  organizationRole: Role
  refetchQueries: PureQueryOptions[]
  refresh: () => Promise<any>
  bulk?: boolean
}

function getConfirmationProps({
  organizationRole,
  servers,
  bulk
}: {
  organizationRole: Role
  servers: Server[]
  bulk: boolean
}) {
  const requiredRole: Role = 'VIEW'
  const tagCount = servers.length === 0 ? 0 : servers[0].tags.length
  const showTagCount = tagCount > 0 && servers.length === 1 && !bulk

  return {
    isActionValid: true,
    requiredRole,
    iconMetadata: showTagCount ? (
      <>
        <TagCount tagCount={tagCount} />{' '}
      </>
    ) : undefined,
    icon: IconTag,
    iconTooltipMessage: { id: 'action_tag', defaultMessage: 'Tag' },
    role: organizationRole,
    iconTooltipPlacement: 'top' as Placement,
    'data-testid': 'action_tag'
  }
}

export function ModifyServerTagsAction({
  servers,
  organizationID,
  organizationRole,
  refetchQueries,
  refresh,
  bulk = false,
  size
}: BulkActionProps) {
  return (
    <ConfirmationRoleAction
      size={size}
      {...getConfirmationProps({ servers, organizationRole, bulk })}
      renderDialog={({ isOpen, closeDialog }: RenderDialogProps) => {
        return (
          <ModifyServerTagsDialog
            organizationID={organizationID}
            serverIDs={servers.map((server) => server.id)}
            closeDialog={closeDialog}
            isOpen={isOpen}
            initialTags={getInitialTags(servers)}
            refetchQueries={refetchQueries}
            refresh={refresh}
          />
        )
      }}
    />
  )
}

interface BulkByFilterActionProps extends BulkActionProps {
  excludedServers: Server[]
  filters: any
  organizationRole: Role
}

export function ModifyServerTagsByFilterAction({
  servers,
  organizationID,
  organizationRole,
  excludedServers,
  filters,
  refetchQueries,
  refresh,
  bulk = false,
  size
}: BulkByFilterActionProps) {
  return (
    <ConfirmationRoleAction
      size={size}
      {...getConfirmationProps({ organizationRole, servers, bulk })}
      renderDialog={({ isOpen, closeDialog }) => {
        return (
          <ModifyServerTagsByFilterDialog
            organizationID={organizationID}
            excludedServers={excludedServers.map((server) => server.id)}
            isOpen={isOpen}
            closeDialog={closeDialog}
            initialTags={getInitialTags(servers)}
            filters={filters}
            refetchQueries={refetchQueries}
            refresh={refresh}
            serverIDs={servers.map((server) => server.id)}
          />
        )
      }}
    />
  )
}
